/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { getBaseQueryKey, mergeQueryKeys } from "../utils/queryKeyHelpers";
import { reportMutationKeyGroups } from "./reportMutationKeys";
import { auditLogRefreshKeys } from "./sharedRefreshKeys";

const baseServiceChargeKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.service_charges)
);

// A change into or out of Fee or Tip rewrites past order amounts, tips and payments, as an order
// import does, plus the reports that read them.
const recalculatedOrderKeys = mergeQueryKeys(
  reportMutationKeyGroups.fetchOrders,
  getBaseQueryKey(Query_Keys.dashboard_overview),
  getBaseQueryKey(Query_Keys.tip_compliance),
  getBaseQueryKey(Query_Keys.discount_reports),
  getBaseQueryKey(Query_Keys.discount_report_summary),
  getBaseQueryKey(Query_Keys.discount_report_breakdown)
);

export const serviceChargeMutationKeyGroups = {
  fetch: mergeQueryKeys(baseServiceChargeKeys, auditLogRefreshKeys),
  update: baseServiceChargeKeys,
  recalculate: recalculatedOrderKeys,
};
